// extracted by mini-css-extract-plugin
export default {"wrapper":"UiSignatureZone_wrapper","content":"UiSignatureZone_content","canvas":"UiSignatureZone_canvas","buttons":"UiSignatureZone_buttons"};